import React from 'react';
import {Card} from "react-bootstrap";
import {Link} from "react-router-dom";
import SA_RejectScouting from "../../../../ui/sweetalert/SA_RejectScouting";
import SA_RejectScoutingDone from "../../../../ui/sweetalert/SA_RejectScoutingDone";
import classes from "classnames";

import user from "../../../../../assets/img/demo/player-avatar-48-1.png";
import "../../../../../assets/sass/pages/scouting/scouting-invites-card.scss";
import "../../../../../assets/sass/pages/scouting/reject-scouting-modal.scss";

class ScoutingInvitesCard extends React.Component {

    rejectClick = (event) => {
        new SA_RejectScouting().fire({},{
            avatar: user,
            to: { name: "Eduardo Miles", role: "RWF | Hardfoot Football Club | Spain"},
            from: { name: "Mark Henry", role: "Manager | Hardfoot Football Club"},
        }).then((result) => {
            if (result.value) {
                return new SA_RejectScoutingDone().fire({},{
                    avatar: user,
                    to: { name: "Eduardo Miles", role: "RWF | Hardfoot Football Club | Spain"},
                    from: { name: "Mark Henry", role: "Manager | Hardfoot Football Club"},
                })
            }
        })
    }

    render() {
        return (
            <Card className={classes('scouting-invites-card', this.extraCardClass())}>
                <Card.Body className="p-0">
                    <div className="member">
                        <img src={user} />
                        <div>
                            <h2>Eduardo Miles</h2>
                            <span>RWF | Hardfoot Football Club | Spain</span>
                        </div>
                    </div>
                    <span>Invite From</span>
                    <div className="member">
                        {/*<img src={user} />*/}
                        <div>
                            <h2>Mark Henry</h2>
                            <span>Manager | Hardfoot Football Club</span>
                        </div>
                    </div>
                </Card.Body>
                <Card.Footer>
                    {this.leftFooter()}
                    {this.rightFooter()}
                </Card.Footer>
            </Card>
        )
    }

    extraCardClass = () => {
        return '';
    }

    leftFooter = () => {
        return (
            <div className="left-side">
                <button className="btn link sm" onClick={this.rejectClick}>Reject</button>
            </div>
        );
    }

    rightFooter = () => {
        return (
            <div className="right-side">
                <Link to="/scouting/full-profile" className="btn secondary sm">Player Details</Link>
                <Link to="/scouting/player-evaluation" className="btn primary sm">Start Scouting</Link>
            </div>
        );
    }
}

export default ScoutingInvitesCard;
